<template>
    <div class="modal fade" :class="{ 'is-open': open }">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">新增特殊條件</h3>
                </div>
                <div class="modal-body">
                    <form class="form">
                       <div class="row">
                           <!-- 特殊條件編號 -->
                            <div class="col-12">
                                <div class="form-group row">
                                  <label class="col-4 text-right" for="code">特殊條件編號</label>
                                  <div class="col-8">
                                    <input class="form-control form-control-inline w-50" id="code" type="text" maxlength="20" v-model="formData.code" disabled/>
                                  </div>
                                </div>
                            </div>
                            <!-- 特殊條件名稱 -->
                            <div class="col-12">
                                <div class="form-group row">
                                  <label class="col-4 text-right" for="codeName">特殊條件名稱</label>
                                  <div class="col-8">
                                      <input class="form-control form-control-inline w-50" id="codeName" type="text" maxlength="20" v-model="formData.code_name"/>                                    
                                  </div>
                                </div>
                            </div>
                       </div> 
                    </form>
                </div>
                <div class="modal-footer">
                    <a @click="doClose()" class="btn btn-default mr-3">取消</a>
                    <a @click="doInsert()" class="btn btn-primary">確認</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getSpecialConditionNextCode, insertSpecialCondition } from "@/service";

export default {
  name: "SpecialConditionAddModal",
  data() {
    return {
      formData: {
        code: "",
        code_name: "",
        special_condition_detail: "",
        memo: "",
        status: "0",
        creator: "",
        creatorname: "",
      },
      userID: "",
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasWarning() {
      return this.formData.shell_level === "0" 
        || (this.formData.shell_level === "1" && this.formData.sum_position === "1");
    },
  },
  watch: {
    //當AddModal被打開時執行initData方法
    open(val) {
      if (val) {
        this.initData();
      }
    },
  },
  methods: {
    /** 初始 */
    async initData() {
      this.userID = this.$store.state.userInfo.id;
      this.formData.creator = this.$store.state.userInfo.id;
      this.formData.creatorname = this.$store.state.userInfo.name;
      this.formData.code = "";
      this.formData.code_name = "";
      await getSpecialConditionNextCode(this.userID).then((result) => {
        if (result.header && result.header.status == "200") {
          this.formData.code = result.data.code;
        } 
      })
    },
    /** 新增保障內容設定 */
    async doInsert() {
      if (!this.formData.code_name) {
        this.$toast.info({ title: "請輸入特殊條件名稱" });
        return;
      }
      if (!confirm("確認要新增特殊條件?")) {
        return;
      }
      await insertSpecialCondition(this.userID, this.formData).then((result) => {
        if (result.header && result.header.status == "200") {
          this.$toast.info({ title: "新增特殊條件成功" });
          this.initData(); //清空資料
          this.$emit("confrim"); //重新讀取頁面
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    /** 關閉AddModal **/
    doClose() {
      this.$emit("close");
    },
    changeShellLevel() {
      if (this.formData.shell_level === "0") this.formData.sum_position = "0";
    }
  },
};
</script>

<style scoped>
.modal.fade .modal-body {
  min-height: auto;
}
</style>
